import MainLayout from '@layouts/main-layout'
import { NextPageWithLayout } from 'types/global'
import Register from '@components/auth/register'

const RegisterPage: NextPageWithLayout = () => {
  return (
    <>
      <Register />
    </>
  )
}

RegisterPage.getLayout = (page) => {
  return <MainLayout>{page}</MainLayout>
}

export default RegisterPage
